




































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Emit, Watch, Mixins, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { quickscanConfig } from '@config';
import RouterHelper from '@helpers/router';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            declined: false,
            config: null,
        }
    },

    created() {
        this.enter();
    },

    methods: {
        showOption(option) {
            return RouterHelper.isAuthorized(this.$router, option.to);
        },

        enter() {
            this.step = parseInt(this.$route.params.step);
            this.config = quickscanConfig[this.step];

            if (!this.config)
                this.$router.push(`/quickscan/`);
        },

        optionClass(option) {
            return `btn-solid--${ option.style } btn--large`;
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class QuickscanStep extends Vue {
    @Emit()
    optionClick(option) {
        switch (option.to) {
            case 'next':
                this.step++;
                this.$router.push(`/quickscan/${ this.step }`);
                break;

            case 'back':
                this.step--;
                this.$router.push(`/quickscan/${ this.step }`);
                break;

            case 'decline':
                this.declined = true;
                break;

            case 'edit':
                this.declined = false;
                break;

            default:
                this.$router.push(option.to);
                break;
        }
    }

    @Watch('$route')
    onRouteChange(to, from) {
        this.enter();
    }
}

